import { HermesPlanner } from '../components/HermesPlanner';

export function HermesPage() {
  return <HermesPlanner />;
}
